import React, { useCallback, useEffect, useState } from "react";
import MobileModuleHeader from "../../components/MobileModuleHeader";
import { useAppDispatch, useAppSelector, useDebounce } from "../../app/hooks";
import { selectLabels } from "../../slices/language";
import { useNavigate } from "react-router-dom";
import { selectUser, selectUserRole } from "../../slices/user";
import api from "../../api";
import { User } from "../../api/models/user-model";
import { CircularProgress } from "@mui/material";
import UserCard from "../../components/UserCard";
import { showError } from "../../utils/helpers";

const MobUsers = () => {
  const labels = useAppSelector(selectLabels);
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);
  const userRole = useAppSelector(selectUserRole);
  const dispatch = useAppDispatch();

  const propertyId = user?.property?.id;

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [searchFilter, setSearchFilter] = useState<string>("");
  const [users, setUsers] = useState<User[] | null>(null);

  const debouncedSearch = useDebounce(searchFilter, 300);

  const getUsers = useCallback(
    async (debouncedText: string) => {
      if (propertyId) {
        try {
          setIsLoading(true);
          if (userRole === "admin") {
            const response = await api.usersListPaginationRequest(
              debouncedText,
              propertyId
            );
            if (response) {
              setUsers(response);
            }
          } else {
            const responseTotal = await api.usersListRequest(
              debouncedText,
              user?.property?.id
            );
            if (responseTotal) {
              setUsers(responseTotal);
            }
          }
        } catch (error: any) {
          console.error(error);
          const errorMessage = error?.response?.data?.error?.message;
          showError(
            dispatch,
            errorMessage ? errorMessage : labels.generic_error
          );
        } finally {
          setIsLoading(false);
        }
      }
    },
    [dispatch, labels.generic_error, propertyId, user?.property?.id, userRole]
  );

  useEffect(() => {
    getUsers(debouncedSearch);
  }, [debouncedSearch, getUsers]);

  return (
    <div className="mobile-module-body" style={{ position: "relative" }}>
      <div
        style={{
          zIndex: 99,
          position: "relative",
        }}
      >
        <MobileModuleHeader
          title={labels.users}
          titleIcon={"fa-solid:users"}
          searchValue={searchFilter}
          setSearchValue={setSearchFilter}
          hasSearch={true}
          hasFilters={false}
          isDowloadable={false}
          hasNewButton={userRole === "guard" ? false : true}
          newButtonAction={() => navigate("/new-user")}
        />
      </div>
      <div
        className={"mobile-module-body-no-filters-content"}
        style={{ zIndex: 10, position: "relative" }}
      >
        {isLoading ? (
          <div className="w-100 h-100 flex justify-content-center align-items-center">
            <CircularProgress />
          </div>
        ) : (
          <>
            {users &&
              users.length > 0 &&
              users.map((item, index) => {
                // const userRoleItem = item?.role?.name.slice(0, -2);
                return (
                  <UserCard
                    key={`${item?.id}-${index}`}
                    user={item}
                    style={{
                      marginBottom: users.length - 1 === index ? 0 : 8,
                    }}
                    onPress={
                      () => navigate(`/user-details/${item?.id}`)
                      // navigate(`/user-details/${item?.id}/${userRoleItem}`)
                    }
                    role={userRole === "admin" ? "admin" : "user"}
                  />
                );
              })}
          </>
        )}
      </div>
    </div>
  );
};

export default MobUsers;
